import { render, staticRenderFns } from "./InboxFilterComponent.vue?vue&type=template&id=08303ef2&scoped=true&"
import script from "./InboxFilterComponent.vue?vue&type=script&lang=js&"
export * from "./InboxFilterComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08303ef2",
  null
  
)

export default component.exports